const riot = require('riot');

riot.tag2('page-campaigns-single', '<div class="f"> <div class="h100vh sticky t0" data-is="module-sidebar"></div> <div class="w-full f fclm bg-pale_gray"> <div data-is="module-page-header" title="{campaign.name}" back="{true}" breadcrumbs="{breadcrumbs}"></div> <div class="f fclm px40 py36"> <form class="bg-white rounded-8 elevation-default-low mb32" onsubmit="{onGoCampaignEdit}"> <div class="section-padding"> <div class="mb28" data-is="module-section-header" title="基本設定"></div> <div class="mb24"> <div class="text-gray_30 ts-hxs mb8">公開用会社名</div> <div class="ts-pm text-navy">{campaign.display_company_name}</div> </div> <div class="mb24"> <div class="text-gray_30 ts-hxs mb8">公開用キャンペーン名</div> <div class="ts-pm text-navy">{campaign.display_name}</div> </div> <div class="mb24"> <div class="text-gray_30 ts-hxs mb8">お問合せ先名</div> <div class="ts-pm text-navy">{campaign.contact_name}</div> </div> <div class="mb24" if="{campaign.contact_email}"> <div class="text-gray_30 ts-hxs mb8">お問合せ先メールアドレス</div> <div class="ts-pm text-navy">{campaign.contact_email}</div> </div> <div if="{campaign.contact_site}"> <div class="text-gray_30 ts-hxs mb8">お問合せ先ホームページURL</div> <div class="ts-pm text-navy">{campaign.contact_site}</div> </div> </div> <div if="{app.utils.permission.has(&quot;project_writer&quot;, { company_id: companyId, project_id: projectId})}" data-is="module-section-footer" buttons="{buttons}"></div> </form> <div class="f fclm rounded-8 elevation-default-low bg-white overflow-hidden mb32"> <div class="pt32 px32 pb28" data-is="module-section-header" title="配布ルール一覧"> <yield to="right"> <button class="button primary" if="{app.utils.permission.has(&quot;project_writer&quot;, { company_id: parent.companyId, project_id: parent.projectId})}" onclick="{parent.openPopup}"> <div class="mr4">配布ルールを新規作成</div><i class="icon-cheveron-down fs20 text-white_70"></i> </button> </yield> </div> <div class="f fclm"> <div class="max-height-500" data-is="module-table" schemas="{tableSchemas}" items="{distributionRules}" scroll-type="y"></div> <div class="f fr px28"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> <div class="f fclm gap-32"> <div class="section-padding rounded-8 elevation-default-low bg-white" if="{company.enabled_option_types.includes(companyOptionTypes[&quot;qr_code_authentication&quot;])}"> <div class="mb28" data-is="module-section-header" title="QRコード認証ルール"></div> <div class="f fl"><a class="button primary" href="{qrcodeAuthUrl()}" target="_blank">QRコード認証ルールへ移動</a></div> </div> <div class="section-padding rounded-8 elevation-default-low bg-white" if="{company.enabled_option_types.includes(companyOptionTypes[&quot;gamification_platform&quot;])}"> <div class="mb28" data-is="module-section-header" title="ゲーミフィケーションプラットフォーム"></div> <div class="f fl"><a class="button primary" href="{gamificationPlatformUrl()}" target="_blank">ゲーミフィケーションプラットフォームへ移動</a></div> </div> </div> </div> </div> </div>', 'page-campaigns-single,[data-is="page-campaigns-single"]{display:block}', '', function(opts) {
    const SELECTED_MULTIPLE_PROVIDER_LABEL = "ユーザーが選択";

    this.isLoading = true;
    this.limit = 50;
    this.buttons = [
      {
        type: 'submit',
        text: '編集',
        class: 'outline',
      },
    ];

    this.companyOptionTypes = {
      qr_code_authentication: 'qr_code_authentication',
      gamification_platform: 'gamification_platform',
    };

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      this.isLoading = true;
      this.update();
      var companyId = req.params.company_id;
      var projectId = req.params.project_id;
      var campaign_id = req.params.campaign_id;

      var promises = [
        app.api.child(`companies/${companyId}/projects/${projectId}/distribution_rules`).get({campaign_id, limit: this.limit, offset: 0}),
        app.api.child(`companies/${companyId}/projects/${projectId}/campaigns/${campaign_id}`).get(),
        app.api.child(`companies/${companyId}`).get(),
      ]
      var [{distribution_rules, pagination}, {campaign}, {company}] = await Promise.all(promises);
      this.isLoading = false;
      this.update();

      var breadcrumbs = [
        {
          link: `/app/companies/${companyId}/projects/${projectId}`,
          label: campaign.project.name,
        },
      ];

      this.tableSchemas = [
        {
          id: 'status',
          label: 'ステータス',
          align: 'center',
          class: 'w122 flex-fixed',
          component: 'distribution_rule_status-badge',
        },
        {
          id: 'name',
          label: '配布ルール',
          class: 'min-width-200 w0 flex-auto',
          component: 'link',
          getLink: (item) => `/app/companies/${companyId}/projects/${projectId}/campaigns/${campaign.id}/distribution_rules/${item.id}`,
        },
        {
          id: 'distribution_target_strategies',
          label: '配布方法',
          class: 'w168 flex-fixed',
          getText: (items) => {
            var item = items[0].distribution_target_type;
            var value = app.data.constants.distribution_target_types.find(v => v.id === item);
            return value.name;
          }
        },
        {
          id: 'distribution_point_strategies',
          label: 'ポイントサービス',
          class: 'w220 flex-fixed',
          getText: (items) => {

            if (items.length > 1) return SELECTED_MULTIPLE_PROVIDER_LABEL;

            var item = items[0].point_provider;
            var value = app.data.constants.point_providers.find(v => v.id === item);
            return value.name;
          }
        },
        {
          id: 'menu',
          component: 'material-icon-button',
          align: 'center',
          class: 'flex-fixed w48',
          text: 'more_vert',
          onclick: (item, e) => {
            this.onOpenActionSheet(item, e);
          },
          shouldShow: (item, e) => {
            return !item.archived_at && app.utils.permission.has("project_writer", { company_id: companyId, project_id: projectId}) ;
          },
        },
      ];

      return {
        companyId,
        projectId,
        campaign,
        distributionRules: distribution_rules,
        pagination,
        breadcrumbs,
        company,
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title('キャンペーン詳細', this),
      };
    };

    this.on('mount', () => {
      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator()
        var offset = this.pagination[offset_type];
        try {
          var { distribution_rules, pagination } = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/distribution_rules`).get({campaign_id: this.campaign.id, limit: this.limit, offset})
          this.distributionRules = distribution_rules;
          this.pagination = pagination;
          this.update();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });
    });

    this.onGoCampaignEdit = (e) => {

      if(!app.utils.permission.has("project_writer", { company_id: this.companyId, project_id: this.projectId})) return ;

      e.preventDefault();
      spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}/edit`);
    };

    this.getStatus = (rule) => {
      return {
        draft: {label: '下書き', icon: 'mode_edit', color: 'gray_dark_10'},
        in_review: {label: '審査中', icon: 'panorama_horizontal', color: 'orange'},
        published: {label: '公開中', icon: 'play_circle_filled', color: 'primary_dark_10'},
        archived: {label: 'アーカイブ', icon: 'archive', color: 'gray_dark_20'},

        rejected: {label: '非承認', icon: 'archive', color: 'error'},
      }[rule.status];
    };

    this.goRuleNew = (type) => {
      let url = `/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}/distribution_rules/new/edit`;
      if (type) {
        url += `?type=${type}`;
      }
      spat.router.push(url);
    };

    this.onGoRule = (e) => {
      spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}/distribution_rules/${e.item.rule.id}`);
    };

    this.onPushRouteProject = () => {
      spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}`);
    };

    this.openPopup = (e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "users",
          label: "全員に配布",
          action: () => {
            popup.close();
            this.goRuleNew();
          },
        },
        {
          icon: "sparkles",
          label: "抽選で配布",
          action: () => {
            popup.close();
            this.goRuleNew('raffle');
          },
        },
      ];
      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        position: 'bottom',
        align: { x: 'right' },
        opts: {
          options,
        }
      });
    };

    this.onOpenActionSheet = (item, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "archive",
          label: "アーカイブ",
          action: () => { popup.close(); this.onArchive(item, e); },
          alert: true,
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        }
      });
    };

    this.onArchive = async (item, e) => {
      var result = await app.utils.openModalDialog(
        {
          title: '配布ルールをアーカイブ',
          text: '本当に配布ルールをアーカイブしますか？アーカイブされた配布ルールでのポイント受け取りは行えなくなり、発行済金額も返金されません。\nこの操作を元に戻す事はできません。',
          danger: true,
          positive: 'アーカイブ',
          negative_button_type: 'text',
          size: 'medium',
          check_form: {
            key: '「アーカイブする」と入力してください',
            value: 'アーカイブする',
          },
        }
      );
      if (!result) return;
      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/distribution_rules/${item.id}/archive`).put();
        var { distribution_rules, pagination } = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/distribution_rules`).get({campaign_id: this.campaign.id, limit: this.limit, offset: 0});
        this.distributionRules = distribution_rules;
        this.pagination = pagination;
        this.update();
        spat.modal.alert('アーカイブしました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.qrcodeAuthUrl = () => {
      return `${spat.config.qrcode_feature_domain}/qr/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}/qrcode-authentication-settings`;
    };
    this.gamificationPlatformUrl = () => {

      const actualUrl = `${spat.config.gamification_platform_domain}/gamification/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}/gamification-policies`;
      return `${spat.config.gamification_platform_domain}/gamification/auth?to=${encodeURIComponent(actualUrl)}`;
    };
});